<div class="a-checkbox">
  <input [formControl]="control" type="checkbox" [id]="id" [disabled]="isDisabled$ | async" />
  <label [for]="id">
    <ng-content></ng-content>
  </label>
</div>
